module.exports = __webpack_public_path__ + "static/media/child_usage0.246c45c0.png";